import {
  Box,
  ButtonBase,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const CoverageContainer = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const FiltersRow = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginBottom: '16px',
}));

export const SearchField = styled(TextField)(() => ({
  width: '100%',
  maxWidth: '420px',
  '& .MuiInputBase-root': {
    borderRadius: '24px',
  },
  '& .MuiInputBase-input': {
    padding: '12px 8px',
  },
}));

export const UfFilterWrapper = styled(Box)(() => ({
  width: '200px',
}));

export const PanelContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
}));

export const PanelScrollArea = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  maxHeight: '560px',
  paddingRight: '8px',
  '&::-webkit-scrollbar': { width: 10 },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.dark,
    borderRadius: 10,
    '&:hover': { backgroundColor: theme.palette.primary.main },
  },
  '&::-webkit-scrollbar-track': { margin: '32px 0' },
}));

export const EmptyState = styled(Typography)(() => ({
  fontSize: 14,
  color: '#7c7c7c',
  padding: '24px 12px',
  textAlign: 'center',
}));

export const StateCard = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: alpha(theme.palette.primary.main, 0.6),
  borderRadius: '10px',
  marginBottom: '8px',
  overflow: 'hidden',
}));

export const StateHeader = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  textAlign: 'left',
  gap: '12px',
  padding: '10px 12px',
  fontFamily: 'inherit',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  },
}));

export const StateChevron = styled('span', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  color: theme.palette.primary.main,
  transition: 'transform 0.3s ease',
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  '& .material-symbols-outlined': {
    fontSize: '22px',
  },
}));

export const SummaryUf = styled('span')(({ theme }) => ({
  fontSize: 15,
  fontWeight: 700,
  color: theme.palette.primary.main,
  width: '36px',
  flexShrink: 0,
}));

export const SummaryInfo = styled('span')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
}));

export const SummaryTopLine = styled('span')(() => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: '12px',
  flexWrap: 'wrap',
}));

export const SummaryName = styled('span')(() => ({
  fontSize: 13,
  color: '#7c7c7c',
}));

export const SummaryCounts = styled('span')(() => ({
  fontSize: 13.5,
  color: '#3c3c3c',
}));

export const PolesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '4px 12px 8px',
}));

export const PoleRow = styled(Box)(() => ({
  borderLeft: '1px solid #e0e0e0',
  marginLeft: '8px',
  padding: '4px 12px',
}));

export const PoleRowHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 0',
}));

export const PoleName = styled(Typography)(() => ({
  fontSize: 15,
}));

export const PoleRowActions = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginLeft: 'auto',
}));

export const PoleDisplacement = styled(Typography)(() => ({
  fontSize: 13,
  color: '#7c7c7c',
  whiteSpace: 'nowrap',
}));

export const RowIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  padding: '4px',
  '&:hover': { color: theme.palette.secondary.main },
  '& .material-symbols-outlined': {
    fontSize: '22px',
  },
}));

export const ExpandButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  padding: '4px',
  '& .material-symbols-outlined': {
    fontSize: '22px',
  },
}));

export const MicroregionsBox = styled(Box)(() => ({
  paddingLeft: '44px',
  paddingBottom: '8px',
}));

export const MicroregionsTitle = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 600,
  marginBottom: '4px',
}));

export const MicroregionsList = styled(Box)(() => ({
  borderLeft: '1px solid #d9d9d9',
  paddingLeft: '12px',
}));

export const MicroregionItem = styled(Typography)(() => ({
  fontSize: 14,
  color: '#7c7c7c',
  padding: '2px 0',
}));
